import makeBookingsServiceRequest from '../utils/makeBookingServiceRequest';
import { API_ACTIONS, BOOKING_C2_ENDPOINT_PREFIX } from '../constants/endpoints';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import type {
    GetCustomQuestionsRequest,
    GetCustomQuestionsResponse,
} from './schema/getCustomQuestions';

export const getCustomQuestions = async (
    request: GetCustomQuestionsRequest
): Promise<GetCustomQuestionsResponse | null> => {
    const perfDatapoint = new PerformanceDatapoint('getCustomQuestions');

    try {
        const { smtpAddress, isAuthRequired } = request;
        const res = await makeBookingsServiceRequest({
            endpointPrefix: BOOKING_C2_ENDPOINT_PREFIX,
            smtpAddress,
            action: API_ACTIONS.CUSTOM_QUESTIONS,
            returnFullResponseOnSuccess: true,
            isAuthRequired,
            bwmHeader: true,
        });
        const response = await res.json();
        if (res.ok) {
            perfDatapoint.addCustomData({
                entryPoint: 'booking',
            });
            perfDatapoint.end();
            return response;
        } else {
            const { message, code, details, error } = response;
            perfDatapoint.addCustomData({
                entryPoint: 'booking',
                exceptionName: message,
                responseCode: code,
                responseDetails: JSON.stringify(details),
                responseError: error,
            });
            perfDatapoint.endWithError(DatapointStatus.ServerError);
            return response;
        }
    } catch (error) {
        perfDatapoint.endWithError(DatapointStatus.ServerError);
        return error;
    }
};

export default getCustomQuestions;
